import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f512ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col flex-1 min-h-0"
}
const _hoisted_2 = { class: "scroll-container flex-1 min-h-0" }
const _hoisted_3 = { class: "parent ds-scrollbar text-sm overflow-x-auto" }
const _hoisted_4 = { class: "sticky-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_8 = { class: "hidden md:inline" }
const _hoisted_9 = { class: "inline md:hidden" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "weekDay" }, null, -1))
const _hoisted_13 = { class: "period text-[11px] md:text-[14px] flex gap-1 md:gap-2 items-center justify-center h-8 md:h-12 bg-gray-100" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = ["title"]
const _hoisted_17 = { class: "text-xs font-normal hidden md:inline" }
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "min-w-0 !whitespace-normal [overflow-wrap:anywhere] [hyphens:auto] text-center hidden md:inline" }
const _hoisted_20 = { class: "m-0" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { class: "md:hidden" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = { class: "shift-hours-time" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "m-0 min-w-0 !whitespace-normal [overflow-wrap:anywhere] [hyphens:auto] text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabelBadge = _resolveComponent("LabelBadge")!
  const _component_unidentified_row = _resolveComponent("unidentified-row")!
  const _component_standard_row = _resolveComponent("standard-row")!
  const _component_vacancy_row = _resolveComponent("vacancy-row")!
  const _component_pre_allocation_badge = _resolveComponent("pre-allocation-badge")!

  return ($props.type == 'WEEK')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.weekTableHead, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.label,
                  class: "weekDay card"
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString($setup.abbreviateDay(item.label)), 1)
                ]))
              }), 128)),
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.weekTableHead.map((w) => w.value), (date) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: date,
                  class: "weekDay card"
                }, _toDisplayString(date), 1))
              }), 128))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.weekData?.data, (company) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: company.companyName
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.healthUnities, (unity) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: unity.healthUnitName
                  }, [
                    ($setup.shouldShowUnity(unity))
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("span", null, _toDisplayString(company.companyName), 1),
                            _hoisted_14,
                            (unity.healthUnitIsActive === false)
                              ? (_openBlock(), _createBlock(_component_LabelBadge, {
                                  key: 0,
                                  label: "Inativa",
                                  color: "red",
                                  size: "small",
                                  icon: null
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(unity.healthUnitName), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unity.schedules, (scale) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: scale.scheduleId
                            }, [
                              ($setup.canReadSchedule(scale.scheduleId))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", {
                                      class: "flex flex-col justify-center items-center font-bold bg-white sticky-column",
                                      style: _normalizeStyle({
                      gridRow: `span ${scale.shifts
                        .flatMap((s) => s.hours)
                        .reduce((a, b) => a + b.positions.length, 0)}`
                    }),
                                      title: scale.scheduleName
                                    }, [
                                      _createTextVNode(_toDisplayString(scale.scheduleName) + " ", 1),
                                      _createElementVNode("span", _hoisted_17, _toDisplayString($setup.getTimezoneDetails(scale.scheduleTimezone)?.subtitle), 1)
                                    ], 12, _hoisted_16),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scale.shifts, (shift, shiftIndex) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: shift.shiftId
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shift.hours, (hour, hourIndex) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, {
                                            key: hour.title
                                          }, [
                                            _createElementVNode("div", {
                                              class: "flex flex-col justify-center items-center font-bold bg-white text-xs shift-hours-column",
                                              style: _normalizeStyle({ gridRow: `span ${hour.positions.length}` }),
                                              title: shift.title + ' ' + hour.title
                                            }, [
                                              _createElementVNode("span", _hoisted_19, [
                                                _createElementVNode("span", _hoisted_20, [
                                                  _createTextVNode(_toDisplayString(shift.title) + " ", 1),
                                                  _hoisted_21,
                                                  _createTextVNode(" " + _toDisplayString(hour.title), 1)
                                                ])
                                              ]),
                                              _createElementVNode("span", _hoisted_22, [
                                                _createTextVNode(_toDisplayString(shift.title), 1),
                                                _hoisted_23,
                                                _createElementVNode("span", _hoisted_24, "(" + _toDisplayString(hour.title) + ")", 1)
                                              ])
                                            ], 12, _hoisted_18),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hour.positions, (position, positionIndex) => {
                                              return (_openBlock(), _createElementBlock(_Fragment, { key: positionIndex }, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex flex-col justify-center items-center font-bold bg-white text-xs position-column", $setup.boundaryClass(shiftIndex, hourIndex, positionIndex)]),
                                                  title: position.title
                                                }, [
                                                  _createElementVNode("span", _hoisted_26, _toDisplayString(position.title), 1)
                                                ], 10, _hoisted_25),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(position.stations, (station, stationIndex) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: stationIndex,
                                                    class: _normalizeClass(["day-cell", $setup.boundaryClass(shiftIndex, hourIndex, positionIndex)])
                                                  }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(station, (card, cardIndex) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass([
                              station.length > 1 && cardIndex !== station.length - 1
                                ? 'station-separator'
                                : '',
                              'card-hover cursor-pointer md:hover:z-10 md:hover:scale-110'
                            ]),
                                                        key: cardIndex
                                                      }, [
                                                        ($setup.isUnidentifiedCard(card))
                                                          ? (_openBlock(), _createBlock(_component_unidentified_row, {
                                                              key: 0,
                                                              "responsible-name": card.coverageResponsibleName ?? null,
                                                              note: card.coverageNote ?? null,
                                                              onClick: ($event: any) => ($setup.handleClickStation(company.companyId, card, unity))
                                                            }, null, 8, ["responsible-name", "note", "onClick"]))
                                                          : (!card.opened)
                                                            ? (_openBlock(), _createBlock(_component_standard_row, {
                                                                key: 1,
                                                                onClick: ($event: any) => ($setup.handleClickStation(company.companyId, card, unity)),
                                                                tableType: card.cell,
                                                                photo: card.doctorAvatar ?? undefined,
                                                                crm: card.crm,
                                                                pendences: card?.type?.pendences,
                                                                success: card?.type?.success,
                                                                error: card?.type?.error,
                                                                waiting: card?.type?.waiting,
                                                                hasObservations: !!card.hasObservations,
                                                                doctorPending: !!card?.doctorPending,
                                                                doctorConfirmed: !!card?.doctorConfirmed,
                                                                doctorStationStatus: card?.status,
                                                                name: card?.doctorName,
                                                                ourTeam: card?.ourTeam,
                                                                doctorStationReminderStatus: card?.doctorStationReminderStatus,
                                                                isAlert: card?.isAlert,
                                                                "required-check-not-our-team": 
                                card?.requiredCheckNotOurTeam ?? undefined
                              ,
                                                                "required-check-our-team": card?.requiredCheckOurTeam ?? undefined,
                                                                "exception-summary-status": card?.exceptionSummaryStatus ?? null,
                                                                "post-station-status": card?.postStationStatus ?? null,
                                                                "permanence-tooltip": $setup.getPermanenceTooltip(card),
                                                                "nps-score": card?.doctorNpsScore ?? null
                                                              }, null, 8, ["onClick", "tableType", "photo", "crm", "pendences", "success", "error", "waiting", "hasObservations", "doctorPending", "doctorConfirmed", "doctorStationStatus", "name", "ourTeam", "doctorStationReminderStatus", "isAlert", "required-check-not-our-team", "required-check-our-team", "exception-summary-status", "post-station-status", "permanence-tooltip", "nps-score"]))
                                                            : (_openBlock(), _createBlock(_component_vacancy_row, {
                                                                key: 2,
                                                                onClick: ($event: any) => ($setup.handleClickStation(company.companyId, card, unity))
                                                              }, null, 8, ["onClick"])),
                                                        (!card.opened && $setup.preAllocationOf(card))
                                                          ? (_openBlock(), _createBlock(_component_pre_allocation_badge, {
                                                              key: 3,
                                                              tag: $setup.preAllocationOf(card)!,
                                                              class: "mt-0.5"
                                                            }, null, 8, ["tag"]))
                                                          : _createCommentVNode("", true)
                                                      ], 2))
                                                    }), 128))
                                                  ], 2))
                                                }), 128))
                                              ], 64))
                                            }), 128))
                                          ], 64))
                                        }), 128))
                                      ], 64))
                                    }), 128))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ], 64))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}